import { useProjectParams } from '@hooks/useProjectParams';
import { ModalDialog } from 'components/ModalDialog';
import { RequestStatus } from 'features/request/requestSlice';
import type { IWorkOrderVersionListItem } from 'pages/Project/Common/utils';
import { methodologyMapReverse } from 'types/methodology';
import { RadioGroup } from 'uikit';

import type React from 'react';
import { useCallback, useEffect, useMemo, useState } from 'react';

import { useExportWorkOrderChangeAnalyticsAsExcel, useGetVersionItems } from './hooks';

import Style from './ExportWorkOrderChangeAnalytics.module.css';

interface IExportWorkOrderChangeAnalytics {
    workOrderChangeId: number;
    onClose: () => void;
    label: string;
}

const modalStyle = { width: 520 };

export const ExportWorkOrderChangeAnalytics: React.FC<IExportWorkOrderChangeAnalytics> = (props) => {
    const { methodology } = useProjectParams();

    const { workOrderChangeId, onClose, label } = props;

    const currentMethodology = useMemo(() => {
        if (!methodology) {
            return undefined;
        }

        return methodologyMapReverse[methodology];
    }, [methodology]);

    const { exportWorkOrderChangeAnalyticsAsExcelMakeRequest, exportWorkOrderChangeAnalyticsAsExcelStatus } =
        useExportWorkOrderChangeAnalyticsAsExcel(workOrderChangeId, currentMethodology, onClose);

    const versionsItems = useGetVersionItems(workOrderChangeId, currentMethodology);

    const [versionItem, setVersionItem] = useState<IWorkOrderVersionListItem>();

    const onConfirm = useCallback(() => {
        if (versionItem) {
            exportWorkOrderChangeAnalyticsAsExcelMakeRequest?.(versionItem?.id);
        }
    }, [exportWorkOrderChangeAnalyticsAsExcelMakeRequest, versionItem]);

    useEffect(() => {
        if (versionsItems?.length) {
            setVersionItem(versionsItems[0]);
        }
    }, [versionsItems]);

    const isLoading = exportWorkOrderChangeAnalyticsAsExcelStatus === RequestStatus.FETCHING;

    return (
        <ModalDialog
            title="Выгрузка аналитики изменения НЗ"
            isOpen
            hasOverlay
            withTitleCloseButton
            isOnClickOutsideDisable
            onClose={onClose}
            onConfirm={onConfirm}
            btnConfirmDisabled={!versionItem}
            isCommit={isLoading}
            btnConfirmLabel="Выгрузить"
            btnCancelLabel="Отменить"
            style={modalStyle}
        >
            <div className={Style.exportWorkOrderChangeAnalytics}>
                <div className="current-change">
                    <div className="area-title">Текущая версия Изма:</div>
                    <div className="current-change-title">{label}</div>
                </div>
                <div>
                    <div className="area-title">Выберите сравниваемую версию для выгрузки:</div>
                    <div className="versions">
                        <RadioGroup
                            value={versionItem}
                            items={versionsItems}
                            getItemLabel={(item) => item.labelWithoutChangeNumber}
                            onChange={({ value }) => setVersionItem(value)}
                            getItemKey={({ id }) => id}
                            disabled={isLoading}
                        />
                    </div>
                </div>
            </div>
        </ModalDialog>
    );
};

ExportWorkOrderChangeAnalytics.displayName = 'ExportWorkOrderChangeAnalytics';
